"use client";

import { useRouter } from "next/navigation";
import { buildBlogHref, PER_PAGE_OPTIONS, type BlogQuery } from "@/lib/blog-query";

interface Props {
  query: BlogQuery;
}

export default function BlogPerPageSelect({ query }: Props) {
  const router = useRouter();

  return (
    <form className="flex items-center gap-2 text-sm text-text-muted">
      <label htmlFor="blog-per-page" className="whitespace-nowrap">
        Per page
      </label>
      <select
        id="blog-per-page"
        name="perPage"
        defaultValue={query.perPage}
        onChange={(e) => router.push(buildBlogHref(query, { perPage: Number(e.target.value), page: undefined }))}
        className="cursor-pointer rounded-lg border border-border-subtle bg-bg-card px-3 py-2 text-sm text-text-primary transition-colors focus:border-brand-purple focus:outline-none focus:ring-1 focus:ring-brand-purple/40"
      >
        {PER_PAGE_OPTIONS.map((n) => (
          <option key={n} value={n}>
            {n}
          </option>
        ))}
      </select>
      <noscript>
        <button
          type="submit"
          className="rounded-lg border border-border-subtle bg-bg-card px-3 py-2 text-text-primary"
        >
          Apply
        </button>
      </noscript>
    </form>
  );
}
